import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyGuestHotelSearch = loadable(() => import(/* webpackChunkName: "content/hotel/search/guest" */ './GuestHotelSearch'), 'GuestHotelSearch');
